<template>
  <nav id="navbar" class="navbar navbar-dark navbar-expand-md row">
    <div class="container">

      <button type="button" aria-label="Toggle navigation" aria-controls="nav_collapse" aria-expanded="false" class="navbar-toggler">
        <span class="navbar-toggler-icon"></span>
      </button>

    
      <router-link to="/">
        <a class="navbar-brand col-sm-3 active" target="_self">
          <img src="../assets/zoom-logo.png" alt="Brand" class="logo">
        </a>
      </router-link>
    

      <div class="col-sm-9">
        <ul class="menu" v-if="!logged">
            <li><a href="">How it works</a></li>
            
            <li>
              <router-link to="/freelancer/search" tag="li">
                <a>Find a freelancer</a>
              </router-link>
            </li>
            
            <li>
              <router-link to="/project/search">
                <a href="">Projects wall</a>
              </router-link>
            </li>
            <li><a href="" class="btn btn-outline">SIGN IN</a></li>
            <li><button href="" class="btn btn-success">POST A PROJECT</button></li>
        </ul>

        <ul class="menu" v-else>
          <li>
            <router-link to="/profile/jobs">
              <a>Your jobs</a>
            </router-link>
          </li>

          <li>
            <router-link to="/freelancer/search">
              <a>Find a freelancer</a>
            </router-link>
          </li>

          <li>
            <router-link to="/profile">
              <div class="circle-menu">
                <i class="far fa-envelope"></i>
              </div>  
            </router-link>
          </li>

          <li>
            <router-link to="/notifications">
              <div class="circle-menu">
                <i class="far fa-bell"></i>
              </div>
            </router-link>
          </li>

          <li>
            <div class="circle-menu">
            <el-dropdown @command="handleCommand" trigger="click">
              <span class="el-dropdown-link">
                  IA
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="myprofile">My Profile</el-dropdown-item>
                <el-dropdown-item command="logout">Logout</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
import firebase from 'firebase';

export default {
  data() {
    return {
      logged : true,
      username : ''
    }
  },
  methods: {
    logout() {
      var self = this;
      firebase.auth().signOut()
      .then(() => {
        //sign out successful 
        console.log('Sign out')
        self.$router.push('/');
      })
      .catch((error) => {
        console.log(error)
      })
    },
    handleCommand(command) {
      console.log(command)
      switch(command) {
        case 'logout':
        this.logout()
        break;

        case 'myprofile':
          this.$router.push('/');
        break; 
      }
    }
  },
  beforeMount() {
    var self = this;
    firebase.auth().onAuthStateChanged(function(user) {
      if (user) {

        self.username = user.displayName;
        // User is signed in.
        self.logged = true;
      } else {
        // No user is signed in.
        self.logged = false;
      }

    });
  }
}
</script>

<style scoped>
@import '../assets/css/stylesheet.css';

nav {
  background-image: linear-gradient(to right,#042AB1,#012853);
  min-height: 8em;
}

.container {
  margin-bottom: 3.5em;
}

span {
  color : #fff;
}

ul.menu {
  list-style-type: none;
  margin: 0;
  padding: 0;
  float: right;
}

ul.menu li {
  float: left;
  margin-right: 20px;
}

ul.menu li a {
  color: #fff;
}

ul.menu li a:hover {
  text-decoration: underline;
  text-decoration-color: #38DCAB;
}

.btn {
  font-weight: 600;
  font-size: 0.8em;
  font-family: 'Gotham Pro';
}

.btn-outline {
  border: 1px solid #FFF;
  border-radius: 10%;
}

.btn-outline:hover {
  text-decoration: none;
}

.btn-success {
  background-color: #38DCAB;
  border-radius: 7%;
  color: #fff;
}

.logo {
  width: 10em;
}

.circle-menu {
  border: 1px solid #fff;
  display: inline-block;
  border-radius: 50%;
  box-shadow: 0px 0px 2px #888;
  padding: 0.5em 0.7em;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue